function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { Fragment } from 'react';
import { ArrowRight } from '@finect/tabular-icons/arrowRight';
import { isEmail } from '@finect/front-utils/isEmail';
import { H4 } from '@finect/tabular-core/Headings';
import { keyMap } from '@finect/front-utils/keyMap';
import { Button } from '@finect/tabular-core/Button';
import { goToLoginWithAction } from '@finect/front-core/User';
import { Strong } from '@finect/tabular-core/Strong';
import { Subscribe, EmailInput, ConfirmButton, SubscribeButton, Inner } from './partials';
export var SubscriptionCTA = function (_React$Component) {
  _inherits(SubscriptionCTA, _React$Component);
  var _super = _createSuper(SubscriptionCTA);
  function SubscriptionCTA() {
    var _this;
    _classCallCheck(this, SubscriptionCTA);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      email: '',
      justSubscribed: false
    });
    _defineProperty(_assertThisInitialized(_this), "handleLoggedInSubscription", function () {
      var newNotifications = _objectSpread(_objectSpread({}, _this.props.user.notifications), {
        weekly: true
      });
      _this.props.newsletterAction(newNotifications);
    });
    _defineProperty(_assertThisInitialized(_this), "handleAction", function () {
      var action = {
        action: 'subscribe',
        target: {
          type: 'newsletter'
        },
        email: _this.state.email
      };
      goToLoginWithAction(action);
    });
    _defineProperty(_assertThisInitialized(_this), "handleEmailChange", function (event) {
      _this.setState({
        email: event.target.value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (event) {
      switch (event.keyCode) {
        case keyMap.ENTER:
        case keyMap.RETURN:
          _this.handleAction();
          break;
        default:
          break;
      }
    });
    return _this;
  }
  _createClass(SubscriptionCTA, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var user = this.props.user;
      if (!user || !user.isLoggedIn) return;
      if (user && prevProps.user.notifications && !prevProps.user.notifications.weekly && user.notifications.weekly) {
        this.setState({
          justSubscribed: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var isValid = isEmail(this.state.email);
      var isLoggedIn = this.props.user && this.props.user.isLoggedIn;
      var justSubscribed = this.state.justSubscribed;
      var notifications = isLoggedIn ? this.props.user.notifications : {};
      var _notifications$weekly = notifications.weekly,
        weekly = _notifications$weekly === void 0 ? false : _notifications$weekly;
      if (weekly && !justSubscribed) {
        return null;
      }
      return React.createElement(Inner, {
        withMargin: this.props.withMargin
      }, React.createElement(Subscribe, {
        small: this.props.small,
        borderColor: this.props.borderColor,
        withBorder: this.props.withBorder,
        backgroundColor: this.props.backgroundColor,
        titleFontWeight: this.props.titleFontWeight,
        titleLineHeight: this.props.titleLineHeight
      }, React.createElement(H4, null, this.props.title), this.props.withText && React.createElement("p", null, this.props.text), isLoggedIn ? React.createElement(Fragment, null, React.createElement(SubscribeButton, {
        withPadding: this.props.withPadding,
        buttonColor: this.props.buttonColor,
        buttonBackgroundColor: this.props.buttonBackgroundColor,
        buttonBorderColor: this.props.buttonBorderColor,
        buttonHover: this.props.buttonHover
      }, justSubscribed ? React.createElement("div", null, React.createElement(Strong, null, "\xA1Gracias!")) : React.createElement(Button, {
        width: "auto",
        onClick: this.handleLoggedInSubscription
      }, "Suscribirme", React.createElement(ArrowRight, null)))) : React.createElement(Fragment, null, React.createElement(EmailInput, null, React.createElement("input", {
        onKeyDown: this.handleKeyDown,
        type: "email",
        value: this.state.email,
        placeholder: "Introduce tu e-mail",
        onChange: this.handleEmailChange
      }), React.createElement(ConfirmButton, {
        isValid: isValid,
        onClick: this.handleAction
      }, React.createElement(ArrowRight, null))), React.createElement("small", null, "Introduce tu e-mail para registrarte en Finect."))));
    }
  }]);
  return SubscriptionCTA;
}(React.Component);
_defineProperty(SubscriptionCTA, "defaultProps", {
  title: 'Suscríbete a nuestra newsletter',
  text: 'Suscríbete a nuestra newsletter y recibe cada semana en tu correo el contenido más relevante para ayudarte a invertir mejor.',
  withBorder: true,
  backgroundColor: 'terciaryLL',
  buttonColor: 'terciaryLL',
  buttonBorderColor: null,
  buttonBackgroundColor: 'primary',
  buttonHover: false,
  withText: true,
  withMargin: true,
  withPadding: true,
  small: false
});